import { ErrorBoundaryWithSuspense } from '../../layouts/ErrorBoundary/ErrorBoundaryWithSuspense';
import { AcceptOrderController } from './AcceptOrderController';
import { OrderSummarySkeleton } from './AcceptOrderSkeleton';
import { redirect } from 'next/navigation';
import { getServerFeatureFlag } from '../../statsig/sdk/server';
import { NEXT_ROUTES } from '@bts-web/utils-next-infrastructure';
import { OrderForSummary } from '../../orders/types';

export interface AcceptOfferBaseProps {
  orderId?: string;
  order?: OrderForSummary;
}

export type AcceptOfferPageProps =
  | (AcceptOfferBaseProps & { orderId: string })
  | (AcceptOfferBaseProps & { order: OrderForSummary });

export const AcceptOrder = async (props: AcceptOfferPageProps) => {
  const feature_hasOrdersEnabled = await getServerFeatureFlag(
    'feature_hasOrdersEnabled',
  );

  if (!feature_hasOrdersEnabled) {
    redirect(NEXT_ROUTES.PORTFOLIO);
  }

  return (
    <ErrorBoundaryWithSuspense fallbackOrSkeleton={<OrderSummarySkeleton />}>
      <AcceptOrderController orderId={props.orderId} order={props.order} />
    </ErrorBoundaryWithSuspense>
  );
};
